/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { CloseIcon } from 'assets/icons/CloseIcon'
import { GradientBarChart } from 'components/Chart/GradientBarChart'
import { Title } from 'components/Dashboard/Title'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from 'store'
import { DashboardCard, DCContent, MachineryCardCount, P } from 'styling/GlobalStyles'
import { BodyText } from 'styling/Typography'
import { IWidget } from 'types/dashboard.interface'
import { WidgetEditOverlay } from '../Dashboard.styled'
import { machineryStatusesData } from '../dashboardData'

export const MachineryWidget = ({
  modalOpen,
  removeWidget,
  onDragOver,
  onDragStart,
  onDragDrop,
}: IWidget) => {
  const navigate = useNavigate()
  const { machinery } = useSelector((state: RootState) => state.dashboard)
  const colors = ['#00a368', '#ff9900', '#ff5b5b', '#b46f33', '#30b6d1', '#7f0788', '#3c8f05333']

  const machineryData =
    machinery?.machineStatuses.length > 0
      ? machineryStatusesData.map((m, index) => {
          if (machinery?.machineStatuses.some((s) => s.status == m.id)) {
            const foundStatus = machinery?.machineStatuses.find((ms) => ms.status == m.id)
            return {
              name: machineryStatusesData.find((msd) => msd.id == foundStatus.status).name,
              value: foundStatus.count,
              color: colors[index],
            }
          }
          return { name: m.name, value: 0.1, color: colors[index] }
        })
      : machineryStatusesData.map((msd, index) => ({
          name: msd.name,
          value: 0,
          color: colors[index],
        }))

  return (
    <DashboardCard
      draggable={modalOpen}
      onDragStartCapture={() => {
        onDragStart('machinery', 1)
      }}
      onDrop={onDragDrop}
      onDragEnd={(e) => {
        e.preventDefault()
      }}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('machinery')
      }}
      width='1fr'
      style={{ gridArea: 'machinery', cursor: modalOpen ? 'grab' : 'normal' }}
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('machinery')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon white />
        </WidgetEditOverlay>
      )}
      <Title
        title='Machinery'
        arrow
        onClick={() => !modalOpen && navigate('/dashboard/machines')}
      />
      <DCContent>
        <MachineryCardCount>
          <BodyText>Total Machinery</BodyText>
          <h3>{machinery?.totalCount}</h3>
        </MachineryCardCount>
        <div style={{ width: '100%', height: '100%' }}>
          <GradientBarChart data={machineryData} />
        </div>
      </DCContent>
    </DashboardCard>
  )
}
